export default __webpack_public_path__ + "static/week4-b3dd32c72dfd730d659b3b6e663c3113.png";